// src/services/cylinderMasterApi.js
import api from "./axiosInstance"; // correct file name
import { TokenManager } from "../utils/tokenManager";

/**
 * 🔹 Create Cylinder
 * POST /api/v1/cylinderMaster/0
 */
export const createCylinder = (data) => {
  console.log("DEBUG: Creating cylinder with data:", data);
  return api.post("cylinderMaster/create", data);
};

/**
 * 🔹 Get Cylinder by ID
 * GET /api/v1/cylinderMaster/{id}
 */
export const getCylinderById = (id) => {
  return api.get(`cylinderMaster/${id}`);
};

/**
 * 🔹 Search Cylinders (Pagination + Filters)
 * GET /api/v1/cylinderMaster/cylinders
 */
export const getCylinders = (params = {}) => {
  console.log("DEBUG: Params:", params);
  
  // Add default sorting if not provided
  const queryParams = {
    sortBy: 'id',
    direction: 'DESC',
    ...params
  };
  
  console.log("DEBUG: Final queryParams:", queryParams);
  console.log("DEBUG: Making API call to: cylinderMaster/cylinders");
  
  return api.get("cylinderMaster/cylinders", {
    params: queryParams
  }).then(response => {
    console.log("DEBUG: API Response received:", response);
    return response;
  }).catch(error => {
    console.error("DEBUG: API Error:", error);
    throw error;
  });
};

/**
 * 🔹 Update Cylinder
 * PUT /api/v1/cylinderMaster/{id}
 */
export const updateCylinder = (id, data) => {
  return api.put(`cylinderMaster/${id}`, data);
};

/**
 * 🔹 Delete Cylinder
 * DELETE /api/v1/cylinderMaster/{id}
 */
export const deleteCylinder = (id) => {
  console.log("DEBUG: Deleting cylinder with ID:", id);
  
  // Check user role and permissions
  const userRole = TokenManager.getUserRole();
  const username = TokenManager.getUsername();
  console.log("DEBUG: User role for delete:", userRole);
  console.log("DEBUG: Username for delete:", username);
  
  // Backend expects a request body with DELETE, send empty object
  const deleteData = {};
  
  return api.delete(`cylinderMaster/${id}`, { data: deleteData })
    .then(response => {
      console.log("DEBUG: Delete successful:", response);
      return response;
    })
    .catch(error => {
      console.error("DEBUG: Delete failed:", error);
      if (error.response?.status === 401) {
        console.error("DEBUG: Authentication failed for delete");
      } else if (error.response?.status === 403) {
        console.error("DEBUG: Authorization failed - user may not have delete permissions");
      }
      throw error;
    });
};

/**
 * 🔹 Get SR Numbers (Autocomplete)
 * GET /api/v1/cylinderMaster/getSrno
 */
export const getSrNos = (cylinderName, status, customerId) => {
  return api.get("cylinderMaster/getSrno", {
    params: { cylinderName, status, customerId },
  });
};

/**
 * 🔹 Track Cylinder by Product Name and Serial Number
 * GET /api/v1/cylinderMaster/track?productName=<productName>&srNo=<serialNumber>
 */
export const trackCylinder = (productName, srNo) => {
  return api.get("cylinderMaster/track", {
    params: { productName, srNo }
  });
};

/**
 * 🔹 Get Cylinder Travel History
 * GET /api/v1/cylinderMaster/travel-history?productName=<productName>&srNo=<serialNumber>
 */
export const getCylinderTravelHistory = (productName, srNo) => {
  return api.get("cylinderMaster/travel-history", {
    params: { productName, srNo }
  });
};

/**
 * 🔹 Get All Cylinders for Dashboard Stats (no pagination)
 * GET /api/v1/cylinderMaster/cylinders?size=1000
 */
export const getAllCylindersForStats = () => {
  return api.get("cylinderMaster/cylinders", {
    params: { size: 1000, sortBy: 'id', direction: 'DESC' }
  });
};

/**
 * 🔹 Check if Cylinder Master has any data
 * GET /api/v1/cylinderMaster/cylinders?size=1
 */
export const checkCylinderMasterHasData = () => {
  return api.get("cylinderMaster/cylinders", {
    params: { size: 1, sortBy: 'id', direction: 'DESC' }
  });
};
